import SchedulerViewProps from './Views'

let KendoSchedulerView = {
    name: 'kendo-scheduler-view',
    render () {
        return null
    },
    mixins: [SchedulerViewProps]
}

export default KendoSchedulerView


// WEBPACK FOOTER //
// ./packages/kendo-scheduler-vue-wrapper/src/KendoSchedulerView/index.js